module.exports = __webpack_public_path__ + "static/ky-cdb2b5367d8b647ab3601ab346d7b09b.svg";